import {createContext, useState} from "react";

const ToastContext = createContext({});

const ToastProvider = (props) => {

  const toastInfo = {
    toast: [],
    setToast: (valor) => {setToast(valor)}
  }

  const [toasts, setToast] = useState(toastInfo);

  return(
    <ToastContext.Provider value={toasts}>
      {props.children}
    </ToastContext.Provider>
  );
}

export {ToastContext, ToastProvider}